export const PROJECT_ROLE_MANAGER = 'manager'
export const PROJECT_ROLE_MEMBER = 'member'
export const PROJECT_ROLE_PENDING = 'pending'
export const PROJECT_ROLE_NONE = 'none'
